import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { ReactComponent as PlusIcon } from '@ubeya/shared-web/assets/plus.svg';
import { CircleIcon, ContextMenu, FlexCenter } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const AvailabilitiesEnum = {
  AVAILABLE: 1,
  UN_AVAILABLE: 0
};

const Wrapper = styled(FlexCenter)`
  height: 100%;
`;

const UnAvailableOption = styled.div`
  color: ${({ theme }) => theme.colors.redNegative};
`;

const AvailableOption = styled.div`
  color: #2fddc9;
`;

const getStatus = (availabilities, group, date) => {
  let result = null;
  (availabilities || []).forEach((availability) => {
    (availability.availabilities || []).forEach(({ labels, date: curDate }) => {
      if (moment(date).format('YYYY-MM-DD') !== moment(curDate).format('YYYY-MM-DD')) {
        return;
      }

      (labels || []).forEach(({ id: labelId, status }) => {
        if (labelId === group) {
          result = status;
        }
      });
    });
  });

  return result;
};

const DayRenderer = ({ group, formattedDate, availabilities, onAvailableChange }) => {
  const { t } = useContext(ConfigContext);

  const options = useMemo(
    () => [
      {
        label: t('availableEmployee'),
        onClick: () =>
          onAvailableChange({
            date: formattedDate,
            status: AvailabilitiesEnum.AVAILABLE,
            labelId: group
          })
      },
      {
        label: t('notAvailableEmployee'),
        onClick: () =>
          onAvailableChange({
            date: formattedDate,
            status: AvailabilitiesEnum.UN_AVAILABLE,
            labelId: group
          })
      }
    ],
    [t, onAvailableChange, formattedDate, group]
  );

  const status = getStatus(availabilities, group, formattedDate);

  return (
    <Wrapper>
      {status === AvailabilitiesEnum.AVAILABLE && (
        <ContextMenu options={options} usePortal>
          <AvailableOption>{t('availableEmployee')}</AvailableOption>
        </ContextMenu>
      )}
      {status === AvailabilitiesEnum.UN_AVAILABLE && (
        <ContextMenu options={options} usePortal>
          <UnAvailableOption>{t('notAvailable')}</UnAvailableOption>
        </ContextMenu>
      )}
      {status == null && (
        <ContextMenu options={options} usePortal>
          <CircleIcon icon={PlusIcon} />
        </ContextMenu>
      )}
    </Wrapper>
  );
};

export default React.memo(DayRenderer);
